import getSnapshots from "./defiantSnapshots.js";
import {performDrugSearch} from "../../../components/drugIndexModalSearch.util.js";
import {formatDrugResults} from "./formatter/formatDrugResults.js";

async function offlineSearchDrug(searchParams) {
    const {
        searchText
    } = searchParams;
    console.log("Performing offline drug search for: ", searchText);

    const {
        guidelinesSnapshot: gSnapshot,
        topicSnapshot: tSnapshot,
    } = await getSnapshots();
    const drugSearchResults = performDrugSearch(searchText, gSnapshot);
    const drugResults = formatDrugResults({
        drugs: drugSearchResults.flattedResults
    }, gSnapshot, tSnapshot);

    return {
        drugResults: drugResults
    };
}

export {
    offlineSearchDrug
};